export default "__VITE_PUBLIC_ASSET__0e9af09d__"